function isTruthyViteFlag(value: string | undefined): boolean {
  const normalized = (value ?? '').trim().toLowerCase();
  return normalized === 'true' || normalized === '1' || normalized === 'yes';
}

/** True when ``VITE_DEBUG`` is set at build/dev-server time (see ``.env.example``). */
export function isClientDebugEnabled(): boolean {
  return isTruthyViteFlag(import.meta.env.VITE_DEBUG);
}

/** Opt-in ``console.log`` for local debugging; no-op when ``VITE_DEBUG`` is unset. */
export function logClientDebug(...args: unknown[]): void {
  if (!isClientDebugEnabled()) {
    return;
  }
  console.log(...args);
}

/**
 * Client-side error logging that avoids leaking stack traces and API payloads in production.
 *
 * Wire production telemetry (e.g. Sentry) here when available.
 */
export function logClientError(context: string, error?: unknown): void {
  if (!import.meta.env.DEV) {
    return;
  }
  console.error(context, error);
}
